import {createRootContextHook} from 'common/util/react';
import {SimpleNavManager} from 'common/contexts/nav-manager/simple-nav-manager';

export const useNavManager = createRootContextHook(`navManager`);

/**
 * Falls back to full-page navigation when rendered outside a context root.
 *
 * @public
 */
export const useNavManagerWithFallback = createRootContextHook(`navManager`, () => new SimpleNavManager());
